var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#0D3B1A"}},[_c('iframe',{staticStyle:{"height":"93vh"},attrs:{"src":"https://statsinfo.co/live/","frameborder":"0","width":"100%"}})])
}]

export { render, staticRenderFns }